import React, { useEffect } from 'react';
import { Row, Col } from '@duxton-web/ui';
// import { Icon } from 'antd';
import { TYPE_INFO_MAPPING } from '../utils/constants';

const ReadOnlyForm = (props) => {
  useEffect(() => {
  }, [props.node]);

  const { node } = props;
  const nodeInfo = TYPE_INFO_MAPPING[node.type];
  return (
    <div className="jb-node-intro-readonly">
      <Row >
        <Col style={{ position: 'absolute' }}>
          <img src={nodeInfo.icon} alt={''} />
        </Col>
        <Col>
          <div className="title">
            {nodeInfo.text}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ReadOnlyForm;
